module.exports = __webpack_public_path__ + "public/img/cv.7a65848b.svg";